import { render } from "./FeatherFileTextSvg.vue?vue&type=template&id=acc825ba"
const script = {}
script.render = render

export default script